<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import chemicalMatrixAPI from "@/services/standards/chemicalMatrix/chemicalMatrixAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";

function blankRow() {
  return {
    area: "", sustancia: "",
    tipo_recipiente: "", material_recipiente: "", cantidad_producto: "",
    etiquetado: null, lugar_uso: "", periodicidad_uso: null, lugar_almacenamiento: "",
    ficha_seguridad: "NO", fds_file: null, no_cas: "", no_un: "",
    peligrosidad: [], palabras_advertencia: null, indicaciones_peligro: "", consejos_prudencia: "",
    prevencion: "", intervencion: "", eliminacion: "", condiciones_almacenamiento: "",
    manipulacion: "", primeros_auxilios: "", epp: "", combatir_fuego: "", derrame: "", observaciones: "",
    _uploadingFds: false,
  };
}

export default {
  page: { title: "Matriz de Sustancias Químicas" },
  components: { Layout, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "4.1.3 Matriz de Sustancias Químicas (SGA/GHS)",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "4.1.3 Matriz de Sustancias Químicas", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      matrixId: this.$route.params.matrix || null,
      catalog: { peligrosidad: [], palabras_advertencia: [], ficha_seguridad: ["SI", "NO"], etiquetado: ["SI", "NO"], periodicidad_uso: [] },
      form: { version: "1.0", fecha: new Date().toISOString().substring(0, 10), observacion: null },
      rows: [blankRow()],
      workflowStatus: "draft",
      signedAt: null,
      submitting: false,
      loading: true,
    };
  },
  computed: {
    isSigned() {
      return this.workflowStatus === "signed";
    },
    chemicalMatrixApi() {
      return {
        pdfUrl: (id) => chemicalMatrixAPI.pdfUrl(id),
        sign: (id, payload) => chemicalMatrixAPI.sign(id, payload),
      };
    },
    conFds() {
      return this.rows.filter((r) => r.ficha_seguridad === "SI" || r.fds_file).length;
    },
  },
  methods: {
    goBack() { this.$router.go(-1); },
    addRow() { if (!this.isSigned) this.rows.push(blankRow()); },
    removeRow(idx) {
      if (this.isSigned) return;
      this.rows.splice(idx, 1);
      if (!this.rows.length) this.rows.push(blankRow());
    },
    fileName(url) { return String(url).split("/").pop(); },
    load() {
      if (!this.matrixId) { this.loading = false; return; }
      chemicalMatrixAPI.get(this.matrixId)
        .then((r) => {
          if (!r) { this.loading = false; return; }
          this.form.version = r.version || "1.0";
          this.form.fecha = r.fecha ? String(r.fecha).substring(0, 10) : this.form.fecha;
          this.form.observacion = r.observacion || null;
          this.rows = (r.rows && r.rows.length)
            ? r.rows.map((x) => ({ ...blankRow(), ...x, peligrosidad: Array.isArray(x.peligrosidad) ? x.peligrosidad : [] }))
            : [blankRow()];
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = { companies_id: this.companyID, ...this.form, rows: this.rows };
      const req = this.matrixId ? chemicalMatrixAPI.update(this.matrixId, payload) : chemicalMatrixAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 43, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Matriz guardada.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          if (!this.matrixId && res && res.id) {
            this.matrixId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/matriz-sustancias/${res.id}` });
          }
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar la matriz", "error"); });
    },
    async onFdsFile(row, event) {
      if (this.isSigned) return;
      const file = event.target.files[0];
      if (!file) return;
      row._uploadingFds = true;
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const path = `${base}/${this.nit}/4.1.3/fds/${this.matrixId || "nuevo"}/${Date.now()}_${file.name}`;
        const ok = await uploadDocument(path, file);
        if (!ok) throw new Error("upload");
        row.fds_file = `${process.env.VUE_APP_BUCKET}/${path}`;
        row.ficha_seguridad = "SI";
        Swal.fire({ title: "FDS cargada", icon: "success", timer: 1200, showConfirmButton: false });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo cargar la ficha de seguridad", "error");
      } finally {
        row._uploadingFds = false;
        if (event.target) event.target.value = null;
      }
    },
    removeFds(row) {
      if (this.isSigned) return;
      row.fds_file = null;
    },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    chemicalMatrixAPI.catalog().then((c) => { if (c) this.catalog = { ...this.catalog, ...c }; });
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Edita el inventario de sustancias químicas (matriz SGA/GHS) en línea. Por cada sustancia documenta su
                clasificación de peligrosidad (pictogramas SGA), palabras de advertencia, frases H (indicaciones de
                peligro) y P (consejos de prudencia), controles, almacenamiento, manipulación, primeros auxilios y EPP, y
                adjunta su Ficha de Datos de Seguridad. Cada guardado es una versión y puede firmarse.
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Esta versión ya fue firmada; los datos quedan bloqueados. Usa "Nueva versión" en el listado para crear una revisión editable.
            </div>

            <form @submit.prevent="save">
              <div class="form-row">
                <b-form-group class="col-md-2 px-2" label="Versión">
                  <b-form-input type="text" v-model="form.version" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha">
                  <b-form-input type="date" v-model="form.fecha" :disabled="isSigned" required />
                </b-form-group>
                <b-form-group class="col-md-7 px-2" label="Observación">
                  <b-form-input type="text" v-model="form.observacion" :disabled="isSigned" />
                </b-form-group>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-2">
                <h5 class="mb-0">Sustancias del inventario</h5>
                <span class="small">
                  <span class="badge badge-primary">Total: {{ rows.length }}</span>
                  <span class="badge badge-success">Con FDS: {{ conFds }}</span>
                </span>
              </div>

              <div v-for="(row, idx) in rows" :key="idx" class="border rounded p-2 mb-3">
                <div class="d-flex justify-content-between">
                  <strong class="small text-primary">Sustancia #{{ idx + 1 }}</strong>
                  <button type="button" class="btn btn-outline-danger btn-sm py-0" :disabled="isSigned" @click="removeRow(idx)">
                    <i class="mdi mdi-trash-can"></i>
                  </button>
                </div>

                <!-- Identificación -->
                <div class="form-row">
                  <b-form-group class="col-md-3 px-2" label="Área"><b-form-input v-model="row.area" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-5 px-2" label="Nombre de la sustancia"><b-form-input v-model="row.sustancia" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="No CAS"><b-form-input v-model="row.no_cas" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="No UN"><b-form-input v-model="row.no_un" :disabled="isSigned" size="sm" /></b-form-group>
                </div>

                <!-- Empaque -->
                <div class="form-row">
                  <b-form-group class="col-md-3 px-2" label="Tipo de recipiente"><b-form-input v-model="row.tipo_recipiente" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Material del recipiente"><b-form-input v-model="row.material_recipiente" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Cantidad del producto"><b-form-input v-model="row.cantidad_producto" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Etiquetado (SGA)">
                    <b-form-select v-model="row.etiquetado" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">—</b-form-select-option>
                      <b-form-select-option v-for="o in catalog.etiquetado" :key="o" :value="o">{{ o }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <!-- Uso y almacenamiento -->
                <div class="form-row">
                  <b-form-group class="col-md-3 px-2" label="Lugar de uso"><b-form-input v-model="row.lugar_uso" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Periodicidad de uso">
                    <b-form-select v-model="row.periodicidad_uso" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">—</b-form-select-option>
                      <b-form-select-option v-for="o in catalog.periodicidad_uso" :key="o" :value="o">{{ o }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Lugar de almacenamiento"><b-form-input v-model="row.lugar_almacenamiento" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Condiciones de almacenamiento"><b-form-input v-model="row.condiciones_almacenamiento" :disabled="isSigned" size="sm" /></b-form-group>
                </div>

                <!-- Clasificación SGA -->
                <div class="form-row bg-light rounded py-1">
                  <b-form-group class="col-md-6 px-2" label="Peligrosidad (pictogramas SGA)">
                    <b-form-checkbox-group v-model="row.peligrosidad" :options="catalog.peligrosidad" :disabled="isSigned" stacked size="sm" class="small" />
                  </b-form-group>
                  <div class="col-md-6">
                    <b-form-group class="px-2" label="Palabra de advertencia">
                      <b-form-select v-model="row.palabras_advertencia" :disabled="isSigned" size="sm">
                        <b-form-select-option :value="null">—</b-form-select-option>
                        <b-form-select-option v-for="o in catalog.palabras_advertencia" :key="o" :value="o">{{ o }}</b-form-select-option>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group class="px-2" label="Indicaciones de peligro (frases H)"><b-form-textarea v-model="row.indicaciones_peligro" :disabled="isSigned" rows="2" size="sm" /></b-form-group>
                    <b-form-group class="px-2" label="Consejos de prudencia (frases P)"><b-form-textarea v-model="row.consejos_prudencia" :disabled="isSigned" rows="2" size="sm" /></b-form-group>
                  </div>
                </div>

                <!-- Gestión del riesgo químico -->
                <div class="form-row">
                  <b-form-group class="col-md-4 px-2" label="Prevención"><b-form-input v-model="row.prevencion" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Intervención"><b-form-input v-model="row.intervencion" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Eliminación"><b-form-input v-model="row.eliminacion" :disabled="isSigned" size="sm" /></b-form-group>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-3 px-2" label="Manipulación"><b-form-input v-model="row.manipulacion" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Primeros auxilios"><b-form-input v-model="row.primeros_auxilios" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="EPP"><b-form-input v-model="row.epp" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Medidas contra el fuego"><b-form-input v-model="row.combatir_fuego" :disabled="isSigned" size="sm" /></b-form-group>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Medidas en caso de derrame"><b-form-input v-model="row.derrame" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Observaciones"><b-form-input v-model="row.observaciones" :disabled="isSigned" size="sm" /></b-form-group>
                </div>

                <!-- Ficha de Datos de Seguridad (FDS) -->
                <div class="form-row align-items-end bg-light rounded py-1">
                  <b-form-group class="col-md-3 px-2" label="¿Tiene FDS?">
                    <b-form-select v-model="row.ficha_seguridad" :disabled="isSigned" size="sm">
                      <b-form-select-option v-for="o in catalog.ficha_seguridad" :key="o" :value="o">{{ o }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Adjuntar Ficha de Datos de Seguridad (pdf, imagen, etc.)">
                    <b-form-file :disabled="isSigned || row._uploadingFds" browse-text="Buscar"
                      :placeholder="row._uploadingFds ? 'Subiendo...' : 'Selecciona un archivo...'" @change="onFdsFile(row, $event)" size="sm" />
                  </b-form-group>
                  <div class="col-md-3 px-2 pb-2 small">
                    <span v-if="row.fds_file">
                      <a :href="row.fds_file" target="_blank"><i class="mdi mdi-paperclip"></i> {{ fileName(row.fds_file) }}</a>
                      <button v-if="!isSigned" type="button" class="btn btn-outline-danger btn-sm py-0 ml-1" @click="removeFds(row)"><i class="mdi mdi-close"></i></button>
                    </span>
                    <span v-else class="text-muted">Sin archivo</span>
                  </div>
                </div>
              </div>

              <button type="button" class="btn btn-outline-primary btn-sm mb-3" :disabled="isSigned" @click="addRow">
                <i class="mdi mdi-plus"></i> Agregar sustancia
              </button>

              <div class="text-right">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && matrixId">
        <h6 class="text-muted small mb-1">Matriz de Sustancias Químicas</h6>
        <DocumentActions
          :document-id="Number(matrixId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="chemicalMatrixApi"
          document-title="Matriz de Sustancias Químicas"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
    </div>
  </Layout>
</template>
